export default __webpack_public_path__ + "static/media/car8.50da32a8.jpg";